import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../components/styles/navbar.css";
import { useNavigate } from "react-router-dom";
import {
  Menu,
  X,
  User,
  LogOut,
  Gamepad2,
  Trophy,
  Newspaper,
  Plus,
} from "lucide-react";
import { useAuth } from "../common/store/authStore";
import CustomAlert from "./custom-alert";

function Navbar() {
  const [click, setClick] = useState(false);
  const [showLogoutAlert, setShowLogoutAlert] = useState(false);
  const { authenticatedUser, clearAuth } = useAuth();
  const isLoggedIn = !!authenticatedUser;

  const navigate = useNavigate();
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const handleLogout = () => {
    clearAuth();
    navigate("/login");
    setShowLogoutAlert(false);
  };
  const defaultProfilePicture =
    "/images/casual-life-3d-profile-picture-of-man-in-green-shirt-and-orange-hat.png";

  return (
    <>
      <nav className="home-navbar">
        {/* Logo */}
        <Link to="/" className="home-navbar-logo" onClick={closeMobileMenu}>
          <img src="/images/chedagaming_logo.png" alt="Cheda Gaming Logo" />
        </Link>

        {/* Desktop Navigation */}
        <ul className={click ? "home-nav-menu active" : "home-nav-menu"}>
          <li className="home-nav-item">
            <Link
              to="/tournaments"
              className="home-nav-links"
              onClick={closeMobileMenu}
            >
              <Trophy size={18} />
              <span>Tournaments</span>
            </Link>
          </li>
          <li className="home-nav-item">
            <Link
              to="/games"
              className="home-nav-links"
              onClick={closeMobileMenu}
            >
              <Gamepad2 size={18} />
              <span>Games</span>
            </Link>
          </li>
          <li className="home-nav-item">
            <Link
              to="/news"
              className="home-nav-links"
              onClick={closeMobileMenu}
            >
              <Newspaper size={18} />
              <span>News</span>
            </Link>
          </li>

          <li className="home-nav-item">
            <Link
              to={isLoggedIn ? "/create-tournament" : "/login"}
              className="home-nav-links"
              onClick={closeMobileMenu}
            >
              <Plus size={18} />
              <span>Create Tournament</span>
            </Link>
          </li>
          {/* Create Bracket Nav Item */}
          {/* <li className="home-nav-item">
            <Link
              to={isLoggedIn ? "/create-bracket" : "/login"}
              className="home-nav-links"
              onClick={closeMobileMenu}
            >
              <Plus size={18} />
              <span>Create Bracket</span>
            </Link>
          </li> */}

          {/* Mobile Auth Links */}
          {!isLoggedIn && (
            <div className="mobile__signup__login">
              <li>
                <Link
                  to="/sign-up"
                  className="home-nav-links-mobile"
                  onClick={closeMobileMenu}
                >
                  Sign Up
                </Link>
              </li>
              <li>
                <Link
                  to="/login"
                  className="home-nav-links-mobile"
                  onClick={closeMobileMenu}
                >
                  Login
                </Link>
              </li>
            </div>
          )}

          {/* Mobile Dashboard & Logout */}
          {isLoggedIn && (
            <>
              <li className="home-nav-item">
                <Link
                  to="/dashboard"
                  className="home-nav-links-mobile"
                  onClick={closeMobileMenu}
                >
                  <User size={18} />
                  <span>Dashboard</span>
                </Link>
              </li>
              <li className="home-nav-item">
                <button
                  onClick={() => setShowLogoutAlert(true)}
                  className="logout-btn-mobile"
                >
                  <LogOut size={18} />
                  <span>Logout</span>
                </button>
              </li>
            </>
          )}
        </ul>

        {/* Desktop Auth Buttons */}
        {!isLoggedIn && (
          <div className="home-sign-up-login-btn">
            <Link to="/sign-up">
              <button className="home-sign-up-btn">Sign Up</button>
            </Link>
            <Link to="/login">
              <button className="home-login-btn">Login</button>
            </Link>
          </div>
        )}

        {/* Desktop User Profile */}
        {isLoggedIn && (
          <div className="user-profile-section">
            <Link to="/dashboard" className="user_dashboard">
              <img
                className="profilepic"
                src={authenticatedUser?.imageUrl || defaultProfilePicture}
                alt="Profile"
              />
            </Link>
          </div>
        )}

        {/* Mobile Menu Icon */}
        <div className="home-menu-icon" onClick={handleClick}>
          {click ? <X size={24} /> : <Menu size={24} />}
        </div>
      </nav>

      <CustomAlert
        isOpen={showLogoutAlert}
        onClose={() => setShowLogoutAlert(false)}
        onConfirm={handleLogout}
        title="Logout"
        message="Are you sure you want to logout?"
        confirmText="Yes, logout"
        cancelText="Cancel"
        type="warning"
      />
    </>
  );
}

export default Navbar;
